import React from "react"
import { useHistory } from 'react-router-dom';
import HashLoader from "react-spinners/HashLoader"
import PacmanLoader from "react-spinners/PacmanLoader"

// Route to landing page
const RouteHome = () => {
    const history = useHistory()

    const goHome = () => {
        history.push('/landing')
    }
    goHome()

    return null
}

const LoadingScreen = ({ size = 150, color = "white" }) => {
    return (
        <div className="section-dark loading-screen" style={{
            minWidth: "100vw",
            minHeight: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        }}>
            <HashLoader
                size={size}
                color={color}
            />
        </div>
    )
}

const LoadingPacman = ({ size = 25, color = "white" }) => {
    return (
        <PacmanLoader
            size={size}
            color={color}
        />
    )
}


export {
    RouteHome,
    LoadingScreen,
    LoadingPacman,
}